export const ExtensionCanvasNavbar = {
  extends: 'Navbar',
  gap: 'A2',
  round: 'radiusPill',
  padding: 'V Z',
  userSelect: 'none',
  theme: 'common-box',
  LogoDropdown: {},
  Inspects: {
    extends: 'NavbarButtonSet',
    gap: 'X2',
    Inspect: {
      title: (el) => el.call('polyglot', 'editor.ext.inspect'),
      icon: 'sf inspect',
      onClick: (ev, el, s) => {
        if (window.chrome && window.chrome.runtime) {
          const extId = window.prompt(
            'What is your extension id?',
            // 'ohaibdehbmoofjegbepabbkaljahdhac',
            'lfjlkobjhaemapiegmoceekipkjgapae'
          )
          window.chrome.runtime.sendMessage(
            extId,
            {
              type: 'toggle_platform_mode'
            },
            (response) => {
              console.log('%creceived response', 'color: skyBlue', response)

              if ('domql' in response) {
                console.log('%cdomql received', 'color: green')

                s.update({
                  value: response.domql
                })
              }
            }
          )
        } else {
          console.error('chrome extension not installed')
        }
      }
    },
    AddToCanvasButton: {
      '!value': {
        opacity: 0.35,
        pointerEvents: 'none'
      },
      extends: 'DropdownButton',
      ignoreChildExtends: true,
      ignoreChildProps: true,
      Button: {
        icon: 'plus oval',
        fontWeight: 400,
        text: '{{ editor.ext.addToCanvas | polyglot }}',
        aspectRatio: 'none',
        onClick: async (ev, el, s) => {
          await el.closeModal()

          const t = setTimeout(() => {
            el.call('openRouterModal', '/add-component', {
              key: 'ParsedComponent',
              title: '',
              type: 'components',
              value: s.value,
              advanced: true
            })
            clearTimeout(t)
          }, 500)
        }
      },
      IconButton: {}
    },
    Edit: {
      disabled: true,
      opacity: 0.35,
      pointerEvents: 'none',
      title: (el) => el.call('polyglot', 'editor.ext.edit'),
      icon: 'sf pencil',
      onClick: (ev, el, s) => {}
    },
    Replace: {
      disabled: true,
      opacity: 0.35,
      title: (el) => el.call('polyglot', 'editor.ext.replace'),
      icon: 'sf replace',
      onClick: (ev, el, s) => {},
      pointerEvents: 'none'
    }
  },
  UrlAddressBar: {
    flex: 1
  },
  History: {
    extends: 'NavbarButtonSet',
    gap: 'X2',
    Undo: {
      title: (el) => el.call('polyglot', 'editor.ext.undo'),
      icon: 'undo',
      onClick: (ev, el, s) => {
        el.sdk.undo()
      }
    },
    Redo: {
      title: (el) => el.call('polyglot', 'editor.ext.redo'),
      icon: 'redo',
      onClick: (ev, el, s) => {
        el.sdk.redo()
      }
    },
    History: {
      title: (el) => el.call('polyglot', 'editor.ext.history'),
      icon: 'sf history',
      onClick: (ev, el, s) => {
        el.getRootState().toggle('isVersionsOpen', {
          preventUpdate: true
        })
        el.getVersionsAside()?.update()
      }
    }
  },
  Meta: {
    extends: 'NavbarButtonSet',
    gap: 'W2',
    InNewTab: {
      icon: 'sf arrow up right',
      title: (el) => el.call('polyglot', 'members.sharingNavbar.newTab'),
      onClick: 'openInNewTab'
    },
    Share: {
      title: (el) => el.call('polyglot', 'members.sharingNavbar.share'),
      icon: 'sf share',
      onClick: (ev, el, s) => {},
      Dropdown: {
        left: 'auto',
        right: '-A',
        ShareDropdown: {}
      },
      extends: ['CanvasButton', 'IconButton', 'DropdownParentFocus']
    }
  },
  Closing: {
    extends: 'NavbarButtonSet',
    gap: 'W2',
    InNewTab: {
      icon: 'question mark',
      title: (el) => el.call('polyglot', 'editor.ext.help')
    },
    Quetion: {
      title: (el) => el.call('polyglot', 'common.action.close'),
      icon: 'crossmark',
      onClick: (ev, el, s) => el.closeModal()
    }
  }
}
